/**
 * Criterio tipo MUI: `boundary` ancla inicio/fin, `sibling` ventana alrededor de la actual.
 * Solo incluye páginas que existen; "..." entre huecos > 1.
 */
export const DEFAULT_PAGINATION_BOUNDARY = 3;
export const DEFAULT_PAGINATION_SIBLING = 1;

export function getVisiblePaginationItems(
  totalPages: number,
  currentPage: number,
  options: { boundary?: number; sibling?: number } = {},
): (number | string)[] {
  const boundary = options.boundary ?? DEFAULT_PAGINATION_BOUNDARY;
  const sibling = options.sibling ?? DEFAULT_PAGINATION_SIBLING;

  if (totalPages < 1) {
    return [];
  }

  const page = Math.min(Math.max(1, currentPage), totalPages);
  const set = new Set<number>();

  for (let i = 1; i <= Math.min(boundary, totalPages); i += 1) {
    set.add(i);
  }
  for (let i = Math.max(1, totalPages - boundary + 1); i <= totalPages; i += 1) {
    set.add(i);
  }
  for (let i = Math.max(1, page - sibling); i <= Math.min(totalPages, page + sibling); i += 1) {
    set.add(i);
  }

  const sorted = [...set].sort((a, b) => a - b);
  const out: (number | string)[] = [];
  let last = 0;

  for (const p of sorted) {
    if (p - last > 1) {
      out.push('...');
    }
    out.push(p);
    last = p;
  }

  return out;
}
